import { render, staticRenderFns } from "./SerieNumeroFormSerieActiva.vue?vue&type=template&id=2591c527&"
import script from "./SerieNumeroFormSerieActiva.vue?vue&type=script&lang=ts&"
export * from "./SerieNumeroFormSerieActiva.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports